import React from 'react';
import { motion } from 'framer-motion';

const SubscriptionLock = () => {
  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/95 backdrop-blur-sm flex items-center justify-center p-4">
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-white w-full max-w-md rounded-3xl p-8 text-center shadow-2xl relative overflow-hidden"
      >
        {/* Decorative Circle */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-500 to-purple-600"></div>

        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center text-4xl mx-auto mb-6">
          🔒
        </div>

        <h2 className="text-2xl font-bold text-slate-800 mb-2">Free Trial Ended</h2>
        <p className="text-slate-500 mb-6">
          To continue using KaamSetu and hiring workers, a small platform fee is required.
        </p>

        <div className="bg-blue-50 p-4 rounded-xl border border-blue-100 mb-6">
          <p className="text-sm text-slate-500 uppercase font-bold tracking-wider mb-1">Monthly Plan</p>
          <div className="text-3xl font-extrabold text-blue-600">
            ₹10 <span className="text-base font-normal text-slate-400">/ month</span>
          </div>
        </div>

        <button 
          onClick={() => alert("Payment Gateway will open here soon!")}
          className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl hover:scale-[1.02] transition-transform"
        >
          Pay ₹10 to Unlock
        </button>

        <p className="text-xs text-slate-400 mt-4">
          Secure payment via UPI / Wallets. Cancel anytime.
        </p>
      </motion.div>
    </div>
  );
};

export default SubscriptionLock;